<template>
  <v-container>
    <h3>アラームメール閾値設定</h3>

    <div class="mt-8 mb-5">

      <v-row>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>チャンネル選択</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 8">
          <v-select density="compact" hide-details="true"
            v-model:model-value="channelKey" :items="channels"></v-select>
        </v-col>
      </v-row>

      <v-divider class="my-7"></v-divider>

      <v-row v-if="channelKey !== ''">
        <v-col cols="12" v-if="!channelKey.startsWith('d') || lowerAlarms.length == 0">
          <h4 class="ms-1">上限値設定</h4>
          <p class="mt-5" v-if="upperAlarms.length == 0">なし</p>
        </v-col>

        <v-col cols="12" v-for="(alarm, index) in upperAlarms" v-bind:key="alarm.threshold">
          <v-card variant="outlined" :elevation="1">
            <v-card-item>
              <v-card-title class="text-subtitle-2 font-weight-bold">
                {{ alarm.threshold }}&nbsp;{{ unit }}&nbsp;以上
              </v-card-title>
            </v-card-item>

            <v-card-text v-show="alarm.isShowDetail">
              <v-row>

                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">画面表示メッセージ</v-label>
                  <p>{{ alarm.screenMessage }}</p>
                </v-col>

                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">アラームメール送信</v-label>
                  <p>{{ alarm.mailTitle != null ? 'する' : 'しない' }}</p>
                </v-col>

                <v-col cols="12" v-if="alarm.mailTitle != null">
                  <v-label class="mb-2 text-subtitle-2">メール件名</v-label>
                  <p>{{ alarm.mailTitle }}</p>
                </v-col>

                <v-col cols="12" v-if="alarm.mailBody != null">
                  <v-label class="mb-2 text-subtitle-2">メール本文</v-label>
                  <p v-html="sanitize(alarm.mailBody).replaceAll('\n', '<br>')"></p>
                </v-col>

              </v-row>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
              <v-btn variant="outlined" rounded="0" class="rounded"
                :icon="alarm.isShowDetail ? 'mdi-menu-up' : 'mdi-menu-down'" size="x-small"
                v-on:click="alarm.isShowDetail = !alarm.isShowDetail;"></v-btn>

              <div v-if="isConfigurable">
                <v-btn icon="mdi-pencil" size="small" v-on:click="showInputDialog('upper', alarm, index);"></v-btn>
                <v-btn icon="mdi-delete" size="small" color="error" v-on:click="deleteAlarm('upper', index);"></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="isConfigurable && (channelKey.startsWith('d') ? (upperAlarms.length == 0 && lowerAlarms.length == 0) : (upperAlarms.length < 5))">
          <v-btn variant="outlined" prepend-icon="mdi-plus" v-on:click="showInputDialog('upper', null);">追加する</v-btn>
        </v-col>


        <v-col cols="12" class="mt-5" v-if="upperAlarms.length > 0 || lowerAlarms.length > 0">
          <h4 class="ms-1">正常値復帰時</h4>
          <p class="mt-5" v-if="recoverdMail == null">通知なし</p>
        </v-col>

        <v-col cols="12" v-if="recoverdMail != null">
          <v-card variant="outlined" :elevation="1">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">メール件名</v-label>
                  <p>{{ recoverdMail.title }}</p>
                </v-col>

                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">メール本文</v-label>
                  <p v-html="sanitize(recoverdMail.body).replaceAll('\n', '<br>')"></p>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="d-flex justify-end" v-if="isConfigurable">
              <v-btn icon="mdi-pencil" size="small"
                v-on:click="showInputDialog('recoverd', { mailTitle: recoverdMail.title, mailBody: recoverdMail.body });"></v-btn>
              <v-btn icon="mdi-delete" size="small" color="error"
                v-on:click="recoverdMail = null;"></v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="isConfigurable && recoverdMail == null && (upperAlarms.length > 0 || lowerAlarms.length > 0)">
          <v-btn variant="outlined" prepend-icon="mdi-plus" v-on:click="showInputDialog('recoverd', null);">メール通知</v-btn>
        </v-col>


        <v-col cols="12" class="mt-5" v-if="!channelKey.startsWith('d') || upperAlarms.length == 0">
          <h4 class="ms-1">下限値設定</h4>
          <p class="mt-5" v-if="lowerAlarms.length == 0">なし</p>
        </v-col>

        <v-col cols="12" v-for="(alarm, index) in lowerAlarms" v-bind:key="alarm.threshold">
          <v-card variant="outlined" :elevation="1">
            <v-card-item>
              <v-card-title class="text-subtitle-2 font-weight-bold">
                {{ alarm.threshold }}&nbsp;{{ unit }}&nbsp;以下
              </v-card-title>
            </v-card-item>

            <v-card-text v-show="alarm.isShowDetail">
              <v-row>

                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">画面表示メッセージ</v-label>
                  <p>{{ alarm.screenMessage }}</p>
                </v-col>

                <v-col cols="12">
                  <v-label class="mb-2 text-subtitle-2">アラームメール送信</v-label>
                  <p>{{ alarm.mailTitle != null ? 'する' : 'しない' }}</p>
                </v-col>

                <v-col cols="12" v-if="alarm.mailTitle != null">
                  <v-label class="mb-2 text-subtitle-2">メール件名</v-label>
                  <p>{{ alarm.mailTitle }}</p>
                </v-col>

                <v-col cols="12" v-if="alarm.mailBody != null">
                  <v-label class="mb-2 text-subtitle-2">メール本文</v-label>
                  <p v-html="sanitize(alarm.mailBody).replaceAll('\n', '<br>')"></p>
                </v-col>

              </v-row>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
              <v-btn variant="outlined" rounded="0" class="rounded"
                :icon="alarm.isShowDetail ? 'mdi-menu-up' : 'mdi-menu-down'" size="x-small"
                v-on:click="alarm.isShowDetail = !alarm.isShowDetail;"></v-btn>

              <div v-if="isConfigurable">
                <v-btn icon="mdi-pencil" size="small" v-on:click="showInputDialog('lower', alarm, index);"></v-btn>
                <v-btn icon="mdi-delete" size="small" color="error" v-on:click="deleteAlarm('lower', index);"></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="isConfigurable && (channelKey.startsWith('d') ? (upperAlarms.length == 0 && lowerAlarms.length == 0) : (lowerAlarms.length < 5))">
          <v-btn variant="outlined" prepend-icon="mdi-plus" v-on:click="showInputDialog('lower', null);">追加する</v-btn>
        </v-col>


        <v-col cols="12" class="mt-5">
          <h4 class="ms-1">メール送信キャンセル時間（分）</h4>
        </v-col>

        <v-col :cols="$vuetify.display.mobile ? 12 : 4">
          <v-form @submit.prevent ref="mainForm">
            <v-text-field density="compact" class="ms-1"
              :rules="[ v => (v && Number.isInteger(Number(v)) && 0 <= Number(v) && Number(v) <= 1440) || '必須、数値（0 ～ 1440）' ]"
              persistent-hint hint="必須、数値（0 ～ 1440）"
              v-model="mailSuspendMinutes" :readonly="!isConfigurable"></v-text-field>
          </v-form>
        </v-col>


        <v-col cols="12" class="my-2">
          <v-alert variant="tonal" type="error" v-model="isShowEmptyMessage" closable>
            1つ以上の閾値を設定してください
          </v-alert>

          <v-alert variant="tonal" type="success" v-model="isShowSaveMessage" closable>
            設定を保存しました
          </v-alert>

          <v-alert variant="tonal" type="success" v-model="isShowDeleteMessage" closable>
            設定をすべて削除しました
          </v-alert>
        </v-col>

        <v-col cols="12" class="d-flex justify-space-between" v-if="isConfigurable">
          <v-btn variant="outlined" color="error" v-if="!$vuetify.display.mobile" v-bind:class="{ 'v-hidden': !existsAlarms }"
            :loading="isDeleteLoading" v-on:click="isShowDeleteConfirmDialog = true;">設定をリセット</v-btn>

          <v-btn :elevation="0" color="primary" :loading="isPutLoading" v-on:click="putAlarms">
            保存
          </v-btn>
        </v-col>

        <v-col cols="12" v-if="isConfigurable && $vuetify.display.mobile && existsAlarms">
          <v-btn variant="outlined" color="error"
            :loading="isDeleteLoading" v-on:click="isShowDeleteConfirmDialog = true;">設定をリセット</v-btn>
        </v-col>
      </v-row>

    </div>

    <v-dialog max-width="400" v-model="isShowDeleteConfirmDialog">
      <v-card>
        <v-card-text>
          保存されている設定がすべて削除されます。よろしいですか？
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowDeleteConfirmDialog = false;">
            キャンセル
          </v-btn>
          <v-btn color="error" v-on:click="isShowDeleteConfirmDialog = false; resetAlarms();">
            リセット
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent max-width="800" v-model="isShowInputDialog">
      <v-card height="100dvh">
        <v-card-item>
          <v-card-title>
            {{ thresholdType === 'recoverd' ? '正常値復帰時' : thresholdType === 'upper' ? '上限値設定' : '下限値設定' }}
          </v-card-title>
        </v-card-item>

        <v-card-text class="mt-3">
          <v-form @submit.prevent ref="dialogForm">
            <v-row>

              <v-col cols="12" v-if="thresholdType !== 'recoverd'">
                <v-label class="mb-3">{{ channelKey.startsWith('a') ? '閾値（' + unit + '）' : '閾値' }}</v-label>
                <v-text-field density="compact"
                  :rules="[ v => (!!v) || '必須、数値', v => (v && !isNaN(Number(v))) || '必須、数値' ]"
                  persistent-hint hint="必須、数値"
                  v-model="threshold" :readonly="channelKey.startsWith('d')"></v-text-field>
              </v-col>

              <v-col cols="12" v-if="thresholdType !== 'recoverd'">
                <p class="ms-1">
                  閾値&nbsp;<span class="font-weight-bold text-decoration-underline">{{ thresholdType === 'upper' ? '以上' : '以下' }}</span>&nbsp;の値となったとき
                </p>
              </v-col>

              <v-col cols="12" v-if="thresholdType !== 'recoverd'">
                <v-label class="mb-3">画面表示メッセージ</v-label>
                <v-textarea density="compact" @keydown.enter.prevent counter no-resize rows="2"
                  :rules="[ v => (!!v) || '必須、20文字以内', v => (v && v.length <= 20) || '必須、20文字以内' ]"
                  persistent-hint hint="必須、20文字以内"
                  v-model="screenMessage"></v-textarea>
              </v-col>

              <v-col cols="12" class="mt-3" v-if="thresholdType !== 'recoverd'">
                <v-label>アラームメール</v-label>
                <v-switch inset color="primary" hide-details="true" v-model="isSendMail">
                  <template v-slot:label>送信する</template>
                </v-switch>
              </v-col>

              <v-col cols="12" v-if="isSendMail">
                <v-label class="mb-3">メール件名</v-label>
                <v-textarea density="compact" @keydown.enter.prevent counter no-resize rows="4"
                  :rules="[ v => (!!v) || '必須、50文字以内', v => (v && v.length <= 50) || '必須、50文字以内' ]"
                  persistent-hint hint="必須、50文字以内"
                  v-model="mailTitle"></v-textarea>
              </v-col>

              <v-col cols="12" v-if="isSendMail">
                <v-label class="mb-3">メール本文</v-label>
                <v-textarea density="compact" counter no-resize rows="5"
                  :rules="[ v => (!!v) || '必須、100文字以内', v => (v && v.length <= 100) || '必須、100文字以内' ]"
                  persistent-hint hint="必須、100文字以内"
                  v-model="mailBody"></v-textarea>
              </v-col>

              <v-col cols="12" class="my-2" v-if="isShowConflictMessage">
                <v-alert variant="tonal" type="error" v-model="isShowConflictMessage" closable>
                  同一の閾値設定が存在します
                </v-alert>
              </v-col>

            </v-row>
          </v-form>
        </v-card-text>

        <v-spacer></v-spacer>

        <v-card-actions class="pa-5 d-flex justify-end">
          <v-btn variant="outlined" v-on:click="isShowInputDialog = false;">
            キャンセル
          </v-btn>
          <v-btn variant="outlined" color="primary" v-on:click="updateAlarmList">
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'AlarmThresholdSetting',
  props: {
    moduleId: { type: String },
    isConfigurable: { type: Boolean }
  },

  setup(props) {

    const channelKey = ref('');
    const channels = ref([
      { title: '未選択', value: '' }
    ]);

    const unit = ref('');

    const upperAlarms = ref([]);
    const recoverdMail = ref(null);
    const lowerAlarms = ref([]);


    const isShowInputDialog = ref(false);
    const thresholdType = ref('upper');

    const dialogForm = ref();

    const editingIndex = ref(-1);

    const threshold = ref('');
    const screenMessage = ref('');

    const isSendMail = ref(false);
    const mailTitle = ref('');
    const mailBody = ref('');

    const isShowConflictMessage = ref(false);


    const mainForm = ref();

    const mailSuspendMinutes = ref('0');


    const isShowEmptyMessage = ref(false);

    const isShowSaveMessage = ref(false);
    const isShowDeleteMessage = ref(false);

    const existsAlarms = ref(false);

    const isPutLoading = ref(false);
    const isDeleteLoading = ref(false);

    const isShowDeleteConfirmDialog = ref(false);


    const sanitize = (text) => {

      return text
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');

    }

    const showInputDialog = (type, targetAlarm, index) => {

      thresholdType.value = type;

      if (targetAlarm == null) {

        editingIndex.value = -1;

        if (channelKey.value.startsWith('d')) {
          threshold.value = (thresholdType.value === 'upper') ? '1' : '0';
        } else {
          threshold.value = '';
        }

        screenMessage.value = '';

        isSendMail.value = (thresholdType.value === 'recoverd');

        mailTitle.value = '';
        mailBody.value = '';

      } else {

        editingIndex.value = index;

        if (thresholdType.value !== 'recoverd') {
          threshold.value = targetAlarm.threshold;
          screenMessage.value = targetAlarm.screenMessage;
        }

        if (targetAlarm.mailTitle != null) {

          isSendMail.value = true;

          mailTitle.value = targetAlarm.mailTitle;
          mailBody.value = targetAlarm.mailBody;

        } else {

          isSendMail.value = false;

          mailTitle.value = '';
          mailBody.value = '';

        }

      }

      isShowConflictMessage.value = false;

      isShowInputDialog.value = true;

    };

    const updateAlarmList = async () => {

      const { valid } = await dialogForm.value.validate();
      if (!valid) {
        return;
      }


      if (thresholdType.value === 'recoverd') {
        recoverdMail.value = {
          title: mailTitle.value,
          body: mailBody.value
        };

        isShowInputDialog.value = false;

        return;
      }


      let item = {
        isShowDetail: true,

        threshold: Number(threshold.value).toString(),
        screenMessage: screenMessage.value
      };

      if (isSendMail.value) {
        item.mailTitle = mailTitle.value;
        item.mailBody = mailBody.value;
      }


      if (thresholdType.value === 'upper') {

        if (isConflict(upperAlarms, item)) {

          isShowConflictMessage.value = true;
          return;

        } else {

          if (editingIndex.value != -1) {
            upperAlarms.value[editingIndex.value] = item;
          } else {
            upperAlarms.value.push(item);
          }

          upperAlarms.value.sort((a, b) => {
            return Number(b.threshold) - Number(a.threshold);
          });

        }

      } else {

        if (isConflict(lowerAlarms, item)) {

          isShowConflictMessage.value = true;
          return;

        } else {

          if (editingIndex.value != -1) {
            lowerAlarms.value[editingIndex.value] = item;
          } else {
            lowerAlarms.value.push(item);
          }

          lowerAlarms.value.sort((a, b) => {
            return Number(b.threshold) - Number(a.threshold);
          });

        }

      }

      isShowInputDialog.value = false;

    };

    const isConflict = (alarms, newItem) => {

      for (let i = 0; i < alarms.value.length; i++) {
        if (alarms.value[i].threshold === newItem.threshold) {
          return (i != editingIndex.value);
        }
      }

      return false;

    };


    const deleteAlarm = (type, index) => {

      if (type === 'upper') {
        upperAlarms.value.splice(index, 1);
      } else {
        lowerAlarms.value.splice(index, 1);
      }


      if (upperAlarms.value.length == 0 && lowerAlarms.value.length == 0) {
        recoverdMail.value = null;
      }

    };


    onMounted(() => {
      fetchChannelList();

      watch(channelKey, () => {

        for (let i = 0; i < channels.value.length; i++) {
          if (channels.value[i].value === channelKey.value) {
            unit.value = channels.value[i].unit;
            break;
          }
        }

        upperAlarms.value = [];
        recoverdMail.value = null;
        lowerAlarms.value = [];

        isShowEmptyMessage.value = false;

        isShowSaveMessage.value = false;
        isShowDeleteMessage.value = false;

        if (channelKey.value === '') {
          return;
        }

        getAlarms();

      });
    });

    const fetchChannelList = () => {
      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        for (let key in response.data.channels) {
          if (key.startsWith('a')) {
            channels.value.push({
              title: '（アナログ' + key.substring(1) + '）' + response.data.channels[key].name,
              value: key,
              unit: response.data.channels[key].unit
            });
          }
        }

        if ('d1' in response.data.channels) {
          channels.value.push({
            title: '（デジタル入力1）' + response.data.channels.d1.name,
            value: 'd1',
            unit: ''
          });
        }

        if ('d2' in response.data.channels) {
          channels.value.push({
            title: '（デジタル入力2）' + response.data.channels.d2.name,
            value: 'd2',
            unit: ''
          });
        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });
    };


    const getAlarms = () => {

      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/${ channelKey.value }/alarms`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        if (response.data.upper != null) {

          response.data.upper.forEach((alarm) => {

            const item = {
              threshold: alarm.threshold.toString(),
              screenMessage: alarm.msg
            };

            if ('mailTitle' in alarm) {
              item.mailTitle = alarm.mailTitle;
              item.mailBody = alarm.mailBody;
            }

            upperAlarms.value.push(item);

          });

          if (response.data.recoverd != null) {

            recoverdMail.value = {
              title: response.data.recoverd.mailTitle,
              body: response.data.recoverd.mailBody
            };

          }

          response.data.lower.reverse().forEach((alarm) => {

            const item = {
              threshold: alarm.threshold.toString(),
              screenMessage: alarm.msg
            };

            if ('mailTitle' in alarm) {
              item.mailTitle = alarm.mailTitle;
              item.mailBody = alarm.mailBody;
            }

            lowerAlarms.value.push(item);

          });

          mailSuspendMinutes.value = response.data.mailSuspendMinutes.toString();

          existsAlarms.value = true;

        } else {

          mailSuspendMinutes.value = '0';

          existsAlarms.value = false;

        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const putAlarms = async () => {

      isShowEmptyMessage.value = false;

      isShowSaveMessage.value = false;
      isShowDeleteMessage.value = false;


      const { valid } = await mainForm.value.validate();
      if (!valid) {
        return;
      }


      if (upperAlarms.value.length == 0 && lowerAlarms.value.length == 0) {
        isShowEmptyMessage.value = true;
        return;
      }


      isPutLoading.value = true;


      const reqBody = {};

      if (upperAlarms.value.length > 0) {

        reqBody.upper = [];

        upperAlarms.value.forEach((alarm) => {

          const item = {
            threshold: Number(alarm.threshold),
            msg: alarm.screenMessage
          };

          if ('mailTitle' in alarm) {
            item.mailTitle = alarm.mailTitle;
            item.mailBody = alarm.mailBody;
          }

          reqBody.upper.push(item);

        });

      }

      if (recoverdMail.value != null) {

        reqBody.recoverd = {
          mailTitle: recoverdMail.value.title,
          mailBody: recoverdMail.value.body
        };

      }

      if (lowerAlarms.value.length > 0) {

        reqBody.lower = [];

        lowerAlarms.value.forEach((alarm) => {

          const item = {
            threshold: Number(alarm.threshold),
            msg: alarm.screenMessage
          };

          if ('mailTitle' in alarm) {
            item.mailTitle = alarm.mailTitle;
            item.mailBody = alarm.mailBody;
          }

          reqBody.lower.push(item);

        });

      }

      reqBody.mailSuspendMinutes = Number(mailSuspendMinutes.value);


      axios.put(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/${ channelKey.value }/alarms`,
        reqBody,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        isShowSaveMessage.value = true;

        existsAlarms.value = true;

        isPutLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const resetAlarms = () => {

      isDeleteLoading.value = true;

      isShowEmptyMessage.value = false;

      isShowSaveMessage.value = false;

      axios.delete(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/${ channelKey.value }/alarms`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        upperAlarms.value = [];
        recoverdMail.value = null;
        lowerAlarms.value = [];

        mailSuspendMinutes.value = '0';

        existsAlarms.value = false;

        isShowDeleteMessage.value = true;

        isDeleteLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    return {
      channelKey,
      channels,

      unit,

      upperAlarms,
      recoverdMail,
      lowerAlarms,

      isShowInputDialog,
      thresholdType,

      dialogForm,

      threshold,
      screenMessage,

      isSendMail,
      mailTitle,
      mailBody,

      isShowConflictMessage,

      mainForm,

      mailSuspendMinutes,

      isShowEmptyMessage,

      isShowSaveMessage,
      isShowDeleteMessage,

      existsAlarms,

      isPutLoading,
      isDeleteLoading,

      isShowDeleteConfirmDialog,

      sanitize,

      showInputDialog,
      updateAlarmList,

      deleteAlarm,

      putAlarms,
      resetAlarms
    }

  }
});
</script>
